import React, { useRef } from 'react'
import { actions } from 'react-redux-form'
import styled from 'styled-components'
import { connect } from 'react-redux'
import ImageInput from 'admin/components/image-input'
import { Button } from 'components/styled/button'
import { mapLanguageToComponentProps } from 'admin/i18n'

interface PhotoActionProps {
  i18n: {
    adminCoverPhoto: {
      removePhoto: string
      photo: string
    }
  }
  hasDefault: boolean
  photoModel: string
  dispatch: any
}

const PhotoActionsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`

const PhotoActions = ({
  i18n,
  hasDefault,
  photoModel,
  dispatch,
}: PhotoActionProps) => {
  const imageInputRef = useRef<HTMLInputElement | null>(null)

  const onPhotoClick = (imageInputRef: any) => {
    imageInputRef?.current?.click()
  }

  const resetPhoto = (dispatch: any, photoModel: string) => {
    dispatch(actions.reset(photoModel))
  }

  const removeAction = (
    <Button
      variant="secondary"
      icon="delete_outline"
      text={i18n.adminCoverPhoto.removePhoto}
      onClick={() => {
        resetPhoto(dispatch, photoModel)
      }}
    />
  )
  return (
    <PhotoActionsWrapper>
      {hasDefault ? (
        <Button
          icon="add"
          variant="secondary"
          text={i18n.adminCoverPhoto.photo}
          onClick={() => {
            onPhotoClick(imageInputRef)
          }}
        />
      ) : (
        removeAction
      )}
      <ImageInput
        model={photoModel}
        imageInputRef={imageInputRef}
        accept="image/gif, image/jpeg, image/jpg, image/png"
      />
    </PhotoActionsWrapper>
  )
}

export default connect(mapLanguageToComponentProps())(PhotoActions)
